import { showUnsavedDataAlert } from '../hooks/useShowUnsavedDataAlert';

export const checkUnsavedData = (isDirty: boolean, action: () => void) => {
    if (isDirty) {
        showUnsavedDataAlert(action);
    } else {
        action();
    }
};